import React, { Component } from 'react';
import { NavLink } from 'react-router-dom';
import { assetUrl } from '~/src/config/routes.js';
import cx from 'classnames';
import SVG from 'react-inlinesvg';
import t from '~/src/services/i18n';
import trackEvent from '~/src/services/analytics';
import './Header.scss';

class Header extends Component {
  constructor() {
    super();
    this.state = {
      menuIsToggled: false,
      pageScrolled: false,
    };
  }

  componentDidMount() {
    window.addEventListener('scroll', this.handleScroll);
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.handleScroll);
  }

  handleScroll = () => {
    if (window.pageYOffset > 1) {
      this.setState({ pageScrolled: true });
    } else {
      this.setState({ pageScrolled: false });
    }
  }

  toggleMenu = () => {
    this.setState({menuIsToggled: !this.state.menuIsToggled});
  };

  render() {
    return (
      <div className={cx(
        'header',
        {'scrolled': this.state.pageScrolled}
      )}>
        <button className="menu-toggle" onClick={this.toggleMenu}>
          <SVG src={assetUrl(this.state.menuIsToggled ? 'Icons/close.svg' : 'Icons/menu.svg')} />
        </button>
        <a
          href="https://cloudinary.com/"
          className="header-logo"
          onClick={() => trackEvent({ action: 'navigation', label: 'hp logo' })}
        >
          <img
            src={assetUrl('cloudinary_logo_for_black_bg.svg')}
            alt="Cloudinary Logo"
            width="110"
          />
        </a>
        <nav className={cx('menu-links', { hidden: !this.state.menuIsToggled })}>
          <NavLink exact
            className="nav-link"
            to="/product-gallery/"
            activeClassName="selected"
            onClick={() => trackEvent({ action: 'navigation', label: 'overview' })}
          >
            {t('overview')}
          </NavLink>
          <NavLink exact
            className="nav-link"
            to="/product-gallery/events"
            activeClassName="selected"
            onClick={() => trackEvent({ action: 'navigation', label: 'events analytics' })}
          >
            {t('eventsAndAnalytics')}
          </NavLink>
          <NavLink exact
            className="nav-link"
            to="/product-gallery/transform"
            activeClassName="selected"
            onClick={() => trackEvent({ action: 'navigation', label: 'transformations' })}
          >
            {t('urlTransformation')}
          </NavLink>
        </nav>
        <a
          href="https://cloudinary.com/users/login"
          target="_blank"
          className="sign-up btn btn-primary"
          onClick={() => trackEvent({ action: 'sign up', label: 'intent to sign up' })}
        >
          <span className="full-text">{t('signUp')}</span>
          <span className="short-text">{t('signUpMobile')}</span>
        </a>
      </div>
    );
  }
}

export default Header;
